<template>
  <span>
    <q-btn
      v-if="!label"
      flat round
      :icon="icon"
      @click="$store.commit('basicLayout/showAuthDialog', true)"
    >
      <q-menu
        v-if="!$q.platform.is.mobile"
        width="600px" :offset="[0, 5]"
      >
        <component v-bind:is="authHeaderMenuComponent" />
      </q-menu>
      <q-tooltip anchor="bottom right" self="top right">{{ $t('tools.auth.headerName') }}</q-tooltip>
    </q-btn>
    <q-btn
      v-else
      round outline
      size="sm"
      :label="label"
      @click="$store.commit('basicLayout/showAuthDialog', true)"
    >
      <q-tooltip anchor="bottom right" self="top right">{{ $t('tools.auth.title') }}</q-tooltip>
      <q-menu
        v-if="!$q.platform.is.mobile"
        width="600px" :offset="[0, 5]"
      >
        <component v-bind:is="authHeaderMenuComponent" />
      </q-menu>
    </q-btn>
    <q-dialog
      v-if="$q.platform.is.mobile"
      v-model="showAuthDialog"
    >
      <q-card style="min-width: 350px;">
        <q-card-section>
          <component v-bind:is="authHeaderMenuComponent" />
        </q-card-section>
      </q-card>
    </q-dialog>
  </span>
</template>

<script>
import { QBtn, QDialog, QCard, QCardSection, QMenu, QTooltip } from 'quasar'
import AuthHeaderMenu from './AuthHeaderMenu.vue'

export default {
  props: ['isPanoramaHeader', 'authHeaderMenu'],
  data () {
    return {
      tool: this.$config.tools['auth'],
      authHeaderMenuComponent: this.authHeaderMenu || AuthHeaderMenu
    }
  },
  components: {
    AuthHeaderMenu, QBtn, QDialog, QCard, QCardSection, QMenu, QTooltip
  },
  computed: {
    icon () {
      return this._getOrCall(this.tool.icon)
    },
    to () {
      const value = this._getOrCall(this.tool.to)
      if (typeof value === 'string') {
        return { name: value }
      } else {
        return value
      }
    },
    username () {
      return this.$store.state.auth.username
    },
    label () {
      return this.username && this.username.slice(0, 2).toUpperCase()
    },
    showAuthDialog: {
      set (show) {
        this.$store.commit('basicLayout/showAuthDialog', show)
      },
      get () {
        return this.$store.state.basicLayout.showAuthDialog
      }
    }
  },
  methods: {
    emit (event, value) {
      if (typeof event === 'string' && event) {
        this.$emit('event', { name: event, value })
      } else if (typeof event === 'object' && event.name.toString()) {
        this.$emit('event', event)
      } else {
        this.$except('[HeaderItemHolder.vue] Trying to emit an incorrectly configured event. Check your config.')
      }
    },
    _getOrCall (v) {
      if (v) {
        if (typeof v === 'function') {
          return v.call(this, this.tool)
        } else {
          return v
        }
      }
    }
  },
  watch: {
    username: function (username) {
      if (username) {
        this.$store.commit('basicLayout/showAuthDialog', false)
      }
    }
  }
}
</script>
